// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageDailyUsage,
  PageDailyUsageFromJSON,
  PageDailyUsageToJSON,
} from "../models/PageDailyUsage";
import {
  type ProjectDailyUsage,
  ProjectDailyUsageFromJSON,
  ProjectDailyUsageToJSON,
} from "../models/ProjectDailyUsage";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface ProjectDailyUsageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
}

export interface RequestDailyUsageRecalculationRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantDailyUsageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
}

/**
 *
 */
export class UsageApi extends runtime.BaseAPI {
  /**
   * Creates request options for projectDailyUsage without sending the request
   */
  async projectDailyUsageRequestOpts(
    requestParameters: ProjectDailyUsageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDailyUsage().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDailyUsage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/usage/daily`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Returns the project\'s usage from the latest tenant daily snapshot. This reads the recorded snapshot; it does not recalculate usage. Returns 404 if no snapshot includes the project.
   * Get the latest daily project usage
   */
  async projectDailyUsageRaw(
    requestParameters: ProjectDailyUsageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectDailyUsage>> {
    const requestOptions = await this.projectDailyUsageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProjectDailyUsageFromJSON(jsonValue)
    );
  }

  /**
   * Returns the project\'s usage from the latest tenant daily snapshot. This reads the recorded snapshot; it does not recalculate usage. Returns 404 if no snapshot includes the project.
   * Get the latest daily project usage
   */
  async projectDailyUsage(
    requestParameters: ProjectDailyUsageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectDailyUsage> {
    const response = await this.projectDailyUsageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for requestDailyUsageRecalculation without sending the request
   */
  async requestDailyUsageRecalculationRequestOpts(
    requestParameters: RequestDailyUsageRecalculationRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling requestDailyUsageRecalculation().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/usage/daily`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Queues an asynchronous calculation for the current UTC date. When it completes, it creates or replaces that tenant\'s snapshot for the date. A 202 response means the task was accepted, not completed.
   * Queue recalculation of today\'s tenant usage
   */
  async requestDailyUsageRecalculationRaw(
    requestParameters: RequestDailyUsageRecalculationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.requestDailyUsageRecalculationRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Queues an asynchronous calculation for the current UTC date. When it completes, it creates or replaces that tenant\'s snapshot for the date. A 202 response means the task was accepted, not completed.
   * Queue recalculation of today\'s tenant usage
   */
  async requestDailyUsageRecalculation(
    requestParameters: RequestDailyUsageRecalculationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.requestDailyUsageRecalculationRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantDailyUsage without sending the request
   */
  async tenantDailyUsageRequestOpts(
    requestParameters: TenantDailyUsageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantDailyUsage().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/usage/daily`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Returns paginated daily snapshots, newest first. Each snapshot contains tenant-wide totals and any project breakdowns recorded in the same calculation.
   * List daily tenant usage snapshots
   */
  async tenantDailyUsageRaw(
    requestParameters: TenantDailyUsageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageDailyUsage>> {
    const requestOptions = await this.tenantDailyUsageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageDailyUsageFromJSON(jsonValue));
  }

  /**
   * Returns paginated daily snapshots, newest first. Each snapshot contains tenant-wide totals and any project breakdowns recorded in the same calculation.
   * List daily tenant usage snapshots
   */
  async tenantDailyUsage(
    requestParameters: TenantDailyUsageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageDailyUsage> {
    const response = await this.tenantDailyUsageRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
